// extracted by mini-css-extract-plugin
export default {"mCard":"YC-z","image":"ZC-z","imageNoBackground":"_C-z","imageHasCategory":"aD-z","fullWidth":"bD-z"};